import { render, staticRenderFns } from "./PageReportItem.vue?vue&type=template&id=4afcc803&scoped=true&"
import script from "./PageReportItem.vue?vue&type=script&lang=js&"
export * from "./PageReportItem.vue?vue&type=script&lang=js&"
import style0 from "./PageReportItem.vue?vue&type=style&index=0&id=4afcc803&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afcc803",
  null
  
)

export default component.exports